import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import Page from 'flow/components/Setting/Page';
import SettingSection from 'flow/components/Setting/SettingSection';
import Divider from 'flow/components/ui-components/Divider';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import { PbxParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

const PbxLiveChatSettings = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { channelKey } = useParams<PbxParams>();

    const channelName = useAppSelector((state) =>
        state.channels.getIn(['channels', channelKey, 'channelName']),
    );

    return (
        <Page
            header={i18next.t('pbx.settings')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['pbx.channels.entityKey'], {
                        entityKey: channelKey,
                    }),
                )
            }
        >
            <div className="flex w-full items-center justify-between rounded-sm px-2 py-4 hover:bg-gray-100">
                <div className="flex items-center gap-x-3">
                    {i18next.t('pbx.name')}
                </div>
                <div className="flex items-center">
                    <div className="text-sm text-gray-500">{channelName}</div>
                </div>
            </div>

            <Divider />

            <SettingSection>
                {i18next.t('Queue.Settings.OtherSettings')}
            </SettingSection>

            <RouteLink
                to={generatePath(
                    routes['pbx.channels.channelKey.settings.greeting'],
                    { channelKey },
                )}
            >
                {i18next.t('Channel.Settings.Greeting')}
            </RouteLink>

            <RouteLink
                to={generatePath(
                    routes['pbx.channels.entityKey.settings.statistics'],
                    {
                        entityKey: channelKey,
                    },
                )}
            >
                {i18next.t('Queue.Statistics.Title')}
            </RouteLink>
        </Page>
    );
};

export default PbxLiveChatSettings;
